var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hl-wid ww3 adm-list" }, [
    _c(
      "ul",
      { staticClass: "tab-like" },
      [
        _c("li", { staticClass: "head" }, [
          _c("ul", [
            _c(
              "li",
              {
                staticClass: "title-only",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.toggleSort("title")
                  }
                }
              },
              [
                _c("span", [_vm._v("Title")]),
                _vm._v(" "),
                _c("a", {
                  staticClass: "s-inc",
                  class: { active: _vm.sort.title === true }
                }),
                _vm._v(" "),
                _c("a", {
                  staticClass: "s-dec",
                  class: { active: _vm.sort.title === false }
                })
              ]
            ),
            _vm._v(" "),
            _vm.entity == "User"
              ? _c("li", { staticClass: "author" }, [
                  _c("span", [_vm._v("Admin")])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.entity == "User"
              ? _c("li", { staticClass: "author" }, [
                  _c("span", [_vm._v("Subscription")])
                ])
              : _vm._e()
          ])
        ]),
        _vm._v(" "),
        _vm._l(_vm.items, function(item, ii) {
          return item.parent == null
            ? [
                _c("li", [
                  _c("ul", [
                    _vm.entity != "User"
                      ? _c("li", { staticClass: "title-only" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.select(ii)
                                }
                              }
                            },
                            [_vm._v(_vm._s(item.title))]
                          )
                        ])
                      : _c("li", { staticClass: "title-only" }, [
                          _c(
                            "a",
                            {
                              attrs: { href: "" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.select(ii)
                                }
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  "#" +
                                    (ii + 1) +
                                    " " +
                                    item.firstname +
                                    " " +
                                    item.lastname
                                )
                              )
                            ]
                          )
                        ]),
                    _vm._v(" "),
                    _vm.entity == "User"
                      ? _c("li", { staticClass: "author" }, [
                          _vm._v(
                            _vm._s(
                              item.admin
                                ? "Yes, " + (item.videoCount || 0) + " video(s)"
                                : "No"
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.entity == "User"
                      ? _c("li", { staticClass: "author" }, [
                          _vm._v(
                            _vm._s(
                              item.activePayment
                                ? item.activePayment.endDate
                                : "No"
                            )
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("li", { staticClass: "remove" }, [
                      !item.videoCount && !item.package
                        ? _c(
                            "a",
                            {
                              attrs: { href: "" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.doRemove(ii)
                                }
                              }
                            },
                            [_vm._v("remove")]
                          )
                        : _vm._e()
                    ])
                  ])
                ]),
                _vm._v(" "),
                _vm._l(item.children, function(item2, i2) {
                  return [
                    _c("li", { staticClass: "subitem subitem-2" }, [
                      _c("ul", [
                        _vm.entity != "User"
                          ? _c("li", { staticClass: "title-only" }, [
                              _c(
                                "a",
                                {
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.select(i2, item.children)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item2.title))]
                              )
                            ])
                          : _c("li", { staticClass: "title-only" }, [
                              _c(
                                "a",
                                {
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.select(i2, item.children)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      "#" +
                                        (ii + 1) +
                                        " " +
                                        item2.firstname +
                                        " " +
                                        item2.lastname
                                    )
                                  )
                                ]
                              )
                            ]),
                        _vm._v(" "),
                        _vm.entity == "User"
                          ? _c("li", { staticClass: "author" }, [
                              _vm._v(
                                _vm._s(
                                  item2.admin
                                    ? "Yes, " +
                                        (item2.videoCount || 0) +
                                        " video(s)"
                                    : "No"
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.entity == "User"
                          ? _c("li", { staticClass: "author" }, [
                              _vm._v(
                                _vm._s(
                                  item2.activePayment
                                    ? item2.activePayment.endDate
                                    : "No"
                                )
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("li", { staticClass: "remove" }, [
                          !item2.videoCount && !item2.package
                            ? _c(
                                "a",
                                {
                                  attrs: { href: "" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.doRemove(i2, item.children)
                                    }
                                  }
                                },
                                [_vm._v("remove")]
                              )
                            : _vm._e()
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm._l(item2.children, function(item3, i3) {
                      return [
                        _c("li", { staticClass: "subitem subitem-3" }, [
                          _c("ul", [
                            _vm.entity != "User"
                              ? _c("li", { staticClass: "title-only" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.select(i3, item2.children)
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(item3.title))]
                                  )
                                ])
                              : _c("li", { staticClass: "title-only" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.select(i3, item2.children)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          "#" +
                                            (ii + 1) +
                                            " " +
                                            item3.firstname +
                                            " " +
                                            item3.lastname
                                        )
                                      )
                                    ]
                                  )
                                ]),
                            _vm._v(" "),
                            _vm.entity == "User"
                              ? _c("li", { staticClass: "author" }, [
                                  _vm._v(
                                    _vm._s(
                                      item3.admin
                                        ? "Yes, " +
                                            (item3.videoCount || 0) +
                                            " video(s)"
                                        : "No"
                                    )
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.entity == "User"
                              ? _c("li", { staticClass: "author" }, [
                                  _vm._v(
                                    _vm._s(
                                      item3.activePayment
                                        ? item3.activePayment.endDate
                                        : "No"
                                    )
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("li", { staticClass: "remove" }, [
                              !item3.videoCount && !item3.package
                                ? _c(
                                    "a",
                                    {
                                      attrs: { href: "" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.doRemove(
                                            i3,
                                            item2.children
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("remove")]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ])
                      ]
                    })
                  ]
                })
              ]
            : _vm._e()
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }